import TextLinkWithArrow from './textLinkWithArrow';

export default TextLinkWithArrow;
